import React from 'react';
import { useTranslation } from '../../../i18n';

export interface HouseRunVotePanelProps {
  photoData: string;
  submitterName?: string;
  acceptVotes: number;
  rejectVotes: number;
  hasVoted?: boolean;
  disabled?: boolean;
  onVote: (vote: 'accept' | 'reject') => void;
}

export const HouseRunVotePanel: React.FC<HouseRunVotePanelProps> = ({
  photoData,
  submitterName,
  acceptVotes,
  rejectVotes,
  hasVoted,
  disabled,
  onVote,
}) => {
  const { t } = useTranslation();

  return (
    <div
      style={{
        background: 'rgba(255, 255, 255, 0.06)',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        borderRadius: '1rem',
        padding: '1rem',
        display: 'flex',
        flexDirection: 'column',
        gap: '0.75rem',
      }}
    >
      <div style={{ fontSize: '0.9rem', fontWeight: 600, textAlign: 'center' }}>
        {t('gameplay.houseRun.judgeTitle', { name: submitterName || t('gameplay.houseRun.opponent') })}
      </div>

      <img
        src={photoData}
        alt=""
        style={{
          width: '100%',
          maxHeight: '200px',
          objectFit: 'cover',
          borderRadius: '0.5rem',
        }}
      />

      <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem', fontSize: '0.85rem', opacity: 0.8 }}>
        <span>✅ {acceptVotes}</span>
        <span>❌ {rejectVotes}</span>
      </div>

      {hasVoted ? (
        <p style={{ textAlign: 'center', margin: 0, opacity: 0.7, fontSize: '0.9rem' }}>
          {t('gameplay.houseRun.voteSubmitted')}
        </p>
      ) : (
        <div style={{ display: 'flex', gap: '0.5rem' }}>
          <button
            type="button"
            disabled={disabled}
            onClick={() => onVote('accept')}
            style={{
              flex: 1,
              padding: '0.85rem',
              background: 'rgba(34, 197, 94, 0.2)',
              border: '2px solid #22C55E',
              borderRadius: '0.5rem',
              color: 'white',
              fontWeight: 700,
              cursor: disabled ? 'not-allowed' : 'pointer',
            }}
          >
            {t('gameplay.houseRun.accept')}
          </button>
          <button
            type="button"
            disabled={disabled}
            onClick={() => onVote('reject')}
            style={{
              flex: 1,
              padding: '0.85rem',
              background: 'rgba(239, 68, 68, 0.2)',
              border: '2px solid #EF4444',
              borderRadius: '0.5rem',
              color: 'white',
              fontWeight: 700,
              cursor: disabled ? 'not-allowed' : 'pointer',
            }}
          >
            {t('gameplay.houseRun.reject')}
          </button>
        </div>
      )}
    </div>
  );
};
